import { useReactFlow } from 'reactflow';

import { IconButton, RyeconMinus, RyeconPlus } from '@dbt-labs/sourdough';

import { Subcomponent } from '../utils/subcomponent';

export type ZoomControlsProps = {};

export const ZoomControls: Subcomponent<ZoomControlsProps> = () => {
  const reactFlow = useReactFlow();

  return (
    <div className="pointer-events-auto flex flex-col">
      <IconButton
        className="border-1 w-10 rounded-md rounded-b-none border border-b-0 border-borderMain p-2"
        styleType="secondary"
        buttonType="button"
        testId="zoom-in-button"
        onClick={() => reactFlow?.zoomIn()}
        ryecon={RyeconPlus}
      />
      <IconButton
        className="border-1 w-10 rounded-md rounded-t-none border border-borderMain p-2"
        styleType="secondary"
        testId="zoom-out-button"
        buttonType="button"
        onClick={() => reactFlow?.zoomOut()}
        ryecon={RyeconMinus}
      />
    </div>
  );
};

ZoomControls.displayName = 'ZoomControls';
